export const TOKEN_DECIMALS = 18;
export var Networks;
(function (Networks) {
    Networks[Networks["ETH"] = 4] = "ETH";
    Networks[Networks["POLYGON"] = 137] = "POLYGON";
    Networks[Networks["AVAX"] = 43114] = "AVAX";
    Networks[Networks["BSC"] = 56] = "BSC";
})(Networks || (Networks = {}));
export const DEFAULT_NETWORK = Networks.ETH;
